var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dm-finish-account-setup-form" },
    [
      _c("h5", { staticClass: "border-bottom fw-bold pb-3 mb-4" }, [
        _vm._v("Password")
      ]),
      _vm._v(" "),
      _c("SetPasswordForm", { attrs: { user_data: _vm.userData } }),
      _vm._v(" "),
      _c("h5", { staticClass: "border-bottom fw-bold pb-3 mb-4" }, [
        _vm._v("Preferences")
      ]),
      _vm._v(" "),
      _vm._l(_vm.categories, function(category) {
        return _c("CategoryPreferences", {
          key: "category-" + category.id,
          attrs: { category: category, preferences: _vm.userData.preferences },
          on: {
            changesMade: function($event) {
              _vm.hasChanges = true
            }
          }
        })
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _c(
          "button",
          {
            staticClass: "btn mt-3 mb-4 dm-btn-padding dm-view-as-pdf",
            class: { disabled: !_vm.canSubmit },
            attrs: { disabled: !_vm.canSubmit },
            on: {
              click: function($event) {
                return _vm.submit()
              }
            }
          },
          [_vm._v("Update Password and Preferences")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }